import { useTranslation } from 'react-i18next';

import { Modal } from '@mantine/core';

import AddStorageForm from './AddStorageForm/AddStorageForm';
import styles from './AddStorageModal.module.css';

type AddStorageModalProps = {
   onClose: () => void;
   onSuccess: () => void;
};

const AddStorageModal = ({ onClose, onSuccess }: AddStorageModalProps) => {
   const { t } = useTranslation();

   return (
      <Modal
         opened
         className={styles.modal}
         size={900}
         title={t('add_storage_modal.title')}
         onClose={onClose}
      >
         <div className={styles.container}>
            <AddStorageForm onClose={onClose} onSuccess={onSuccess} />
         </div>
      </Modal>
   );
};

export default AddStorageModal;
